import apiClient from './apiClient';

export const symbolsAPI = {
  // The thematic symbol groups (SPT DWLF-509): [{ name, members }], members in slash form. A member need not
  // be a tracked symbol (the active /symbols list says which are).
  getGroups: async () => {
    const response = await apiClient.get('/symbols/groups');
    if (!Array.isArray(response.data?.groups)) throw new Error('symbol groups: no groups in the response');
    return response.data.groups;
  },
};

export default symbolsAPI;
